import { render, staticRenderFns } from "./AppScarlet.vue?vue&type=template&id=48a586b8&scoped=true&lang=html"
import script from "./AppScarlet.vue?vue&type=script&lang=js"
export * from "./AppScarlet.vue?vue&type=script&lang=js"
import style0 from "./AppScarlet.vue?vue&type=style&index=0&id=48a586b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a586b8",
  null
  
)

export default component.exports